import React, { Component } from 'react';
import * as encryptUtils from "./encryptDecryptUtils";
import PlatformSidebar from "./PlatformSidebar";
import Onboarding from "./Onboarding.js";
import AddFunds from "./AddFunds.js";
import ImportFromPassword from "./ImportFromPassword";

class Subscribers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subscribers: [],
    };
  }

  async componentDidMount() {
    if(this.props.account != null) {
      let authSig = await encryptUtils.getAuthSigForceTestnet();
      let mySubscribers = await encryptUtils.getSubscribers(this.props.account.address, authSig);
      this.setState({
        subscribers: mySubscribers,
      });
    }
  }

  render() {
    return (
      <div className="min-h-screen bg-custom-white dark:bg-custom-black flex flex-col">
        <PlatformSidebar
          modalShown={this.state.modalShown}
          selectModal={this.selectModal}
        />
        {this.state.modalShown === "createAccount" ? (
          <Onboarding selectModal={this.selectModal} />
        ) : this.state.modalShown === "addFunds" ? (
          <AddFunds selectModal={this.selectModal} />
        ) : this.state.modalShown === "importFromPassword" ? (
          <ImportFromPassword selectModal={this.selectModal} />
        ) : null}
        <div className="absolute z-20 top-16 left-24 sm:left-60 right-0 bg-custom-black">
          <div className="mx-12 mt-10 w-12/12">
            <div className="flex">
              <div className="ml-2 w-1/2 text-gray-500 text-md font-semibold dark:text-zinc-400">
                Email
              </div>
              <div className="w-1/2 text-gray-500 text-md font-semibold dark:text-zinc-400">
                Address
              </div>
            </div>
            {
              this.state.subscribers.map((subscriber, ind) => {
                return (
                  <div key={ind} className="h-12 items-center rounded-lg p-2 flex bg-white dark:bg-zinc-800 shadow-sm dark:shadow-2xl mt-2">
                    <div className="w-1/2 text-xs sm: md:text-sm text-base font-medium text-black dark:text-white">
                      {subscriber.email}
                    </div>
                    <div className="w-1/2 text-xs sm:text-base md:text-sm font-medium text-black dark:text-white">
                      {subscriber.address}
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default Subscribers;
